import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    ':not(#__unused__) > button': {
      marginTop: anatomy['space-8'],
      alignSelf: 'flex-start',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
  },
  inputsContainerWithLabel: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    marginTop: '4px',
  },
  title: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: palette['greyWhite'],
  },
  editableTitle: {
    cursor: 'text',
    display: 'block',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: palette['greyWhite'],
    wordBreak: 'break-word',
    width: '100%',
    minHeight: '20px',
  },
  description: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
  },
  addButton: {
    width: '100%',
  },
  warningContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-10'],
  },
  warningText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    width: '327px',
  },
});
